<div class="modal-header" ngbAutofocus>
    <h3 class="modal-title">Copy Expense</h3>
</div>
<div class="modal-body">
    <p>You are about to copy the line {{data.Description}}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="continueClicked()">Continue</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>